import { Alert, AlertColor } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  level?: AlertColor;
  variant?: 'standard' | 'outlined';
  message: ReactNode;
  attention?: boolean;
  hideIcon?: boolean;
  nudge?: boolean;
}

const useStyles = createUseStyles({
  inlineToast: {
    '&.nudge': {
      animation: '$nudge 200ms ease-in-out 4',
    },
  },
  '@keyframes nudge': {
    '0%': {
      transform: 'translateX(0)',
    },
    '50%': {
      transform: 'translateX(-10px)',
    },
    '100%': {
      transform: 'translateX(0)',
    },
  },
});

const InlineToast: FC<Props> = ({
  level = 'info',
  variant = 'standard',
  message,
  attention = false,
  hideIcon = false,
  nudge = false,
}) => {
  const styles = useStyles();
  const showNudge = nudge || attention;
  const compClass = classNames(styles.inlineToast, { nudge: showNudge });

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (attention && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'instant',
      });
    }
  }, [attention]);

  return (
    <Alert
      severity={level}
      className={compClass}
      {...(hideIcon ? { icon: false } : {})}
      ref={ref}
      variant={variant}
    >
      {message}
    </Alert>
  );
};

export default InlineToast;
